import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manager';

const profile = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/merchants`);
};

const activate = (merchantId) => {
	return Client.post(`${baseUrl}/active`, {}, { merchantId });
};

const updateTimezone = (merchantId, timezone) => {
	return Client.post(
		`${baseUrl}/timezone`,
		{
			timezone,
		},
		{ merchantId }
	);
};

const uploadLogo = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/upload/image`,
		payload,
		{ merchantId },
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export default {
	profile,
	activate,
	updateTimezone,
	uploadLogo,
};
